function brontoSendData(listId, email, fields, successCallback, failureCallback) {
  fields = fields || null;
  successCallback = successCallback || function() {};
  failureCallback = failureCallback || function() {};
  $.post( "https://deep-kyiv-77p4gqifeylx.vapor-farm-a1.com/api/bronto", { email: email, list_id: listId, fields: fields }, successCallback, "json").fail(failureCallback);
}


$(function() {

	var body = $('body');
	var header = $('.site-header');


	$('#footer-newsletter-form, .oos-form').submit(function(e) {
		e.preventDefault();
		let _this = $(this);
		let fields = {};
		_this.find('.bronto-field').each(function() {
			fields[$(this).attr('name')] = $(this).val();
		});
		_this.find('.field_error').html('');
		brontoSendData($(this).find('.bronto-list-id').val(), $(this).find('.bronto-email').val(), fields, function() {
			_this.find('.field-wrap').html("<p>Thanks!  We'll be in touch soon!</p>");
		}, function(response) {
			_this.find('.field_error').html("<p>" + response.responseJSON.message + "</p>");
		});
	});

	$('.state-a form').submit(function(e) {
		e.preventDefault();
		let _this = $(this);
		let fields = {};
		_this.find('.bronto-field').each(function() {
			fields[$(this).attr('name')] = $(this).val();
		});
		_this.find('.field_error').html('');
		brontoSendData($(this).find('.bronto-list-id').val(), $(this).find('.bronto-email').val(), fields, function() {
			$('.state-a').slideUp();
			$('.state-b').slideDown();
			$('.bronto-email').val($(_this).find('.bronto-email').val());
		}, function(response) {
			_this.find('.field_error').html("<p>" + response.responseJSON.message + "</p>");
		});
	});

	$('.state-b form').submit(function(e) {
		e.preventDefault();
		let _this = $(this);
		let fields = {};
		_this.find('.bronto-field').each(function() {
			fields[$(this).attr('name')] = $(this).val();
		});
		_this.find('.field_error').html('');
		brontoSendData($(this).find('.bronto-list-id').val(), $(this).find('.bronto-email').val(), fields, function() {

			// Start animation

			console.log('hide form and start animation');

			$('.j-heart-on-success').text('Thanks!');
			$('.heart-animation-container .heart').fadeIn();

			setTimeout(function(){

				$('.j-close-newsletter-modal').trigger('click');

			}, 3000);

		}, function(response) {
			_this.find('.field_error').html("<p>" + response.responseJSON.message + "</p>");
		});
	});


	// Add this script
	function deferIframe() {
	  var iframeElem = document.getElementsByTagName('iframe');
	  for ( var i = 0; i < iframeElem.length; i++ ) {
	    if(iframeElem[i].getAttribute('data-src')) {
	      iframeElem[i].setAttribute('src',iframeElem[i].getAttribute('data-src'));
	    }
	  }
	}
	window.onload = deferIframe;

	// Expand mobile menu
	$(document).on('click', '.j-expand-menu', function(e){

		e.preventDefault();
		$(body).toggleClass('menu-expand');

	});

	// Move header up on scroll

 	var lastScrollTop = 0;

    function headerShrink() {

    	var st = $(this).scrollTop();

        if (st > lastScrollTop) {
            body.addClass('hup');
        } else {
        	body.removeClass('hup');
        }

        lastScrollTop = st;

    }

    $(document).scroll(function() {

        if ( $(document).scrollTop() >= 40 ) {
        	headerShrink();
        }

    });

	// Expand menu accordions
	$(document).on('click', '.j-children-trigger', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().parent().find('ul').slideToggle();

	});

	// Country selector
	$(document).on('click', '.j-country-selection a.active', function(e){

		e.preventDefault();
		$(this).parent().toggleClass('active');

	});

	// Homepage carousel
	$('.j-home-hero-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: true,
		swipeToSlide: true,
		mobileFirst: true,
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		      	variableWidth: true,
		      	centerMode: true
		      }
		    }
		]
	});

	// Product Carousel

	$('.j-product-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		variableWidth: true,
		swipeToSlide: true,
		mobileFirst: true,
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		      	centerMode: true,
		      	arrows: true
		      }
		    }
		]
	});

	// Initialize match height on carousel load

	$('.j-product-carousel .product-card').matchHeight({ property: 'min-height' });

	// Order Product Carousel

	$('.j-order-product-carousel').slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		variableWidth: true,
		swipeToSlide: true,
		mobileFirst: true,
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		      	arrows: true
		      }
		    }
		]
	});

	// Featured products carousel - article page

	$('.j-fa-product-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		variableWidth: true,
		swipeToSlide: true,
		mobileFirst: true,
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		      	arrows: true
		      }
		    }
		]
	});

	// article carousel

	$('.j-article-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		variableWidth: true,
		swipeToSlide: true,
		mobileFirst: true,
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		      	arrows: true
		      }
		    }
		]
	});

	// Logo carousel

	$('.j-logo-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: false,
		variableWidth: true,
		centerMode: true,
		swipeToSlide: true,
		mobileFirst: true
	});

	// Promo message carousel

	$('.j-promo-message-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: false
	});

	// Initialise concern carousel

	$('.j-collection-carousel').slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		dots: false,
		variableWidth: true,
		swipeToSlide: true,
		mobileFirst: true,
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		      	infinite: true
		      }
		    }
		]
	});

	// Initialise stockist carousel

	$('.j-stockist-carouel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		variableWidth: true,
		swipeToSlide: true,
		mobileFirst: true,
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		      	arrows: true
		      }
		    }
		]
	});

	// Initialise how it works carousel - rewards page

	$('.j-hiw-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: true,
		swipeToSlide: true,
		mobileFirst: true,
		responsive: [
		    {
		      breakpoint: 622,
		      settings: "unslick"
		    }
		]
	});

	// Expand footer menu accordions

	if ($(window).width() < 1024) {

		$(document).on('click', '.j-footer-menu-toggle', function(){

			$(this).toggleClass('active').parent().find('ul').slideToggle();

		});

	}

	// Toggle search modal

	$(document).on('click', '.j-toggle-search-modal', function(e){

		e.preventDefault();

	});

	// Search results toggle

	$(document).on('click', '.j-toggle-results', function(e){

		e.preventDefault();
		$(this).addClass('active').siblings().removeClass('active');

		if ( $(this).hasClass('j-show-pr') ){

			$('.search-results-output .results-products').css('display', 'flex');
			$('.search-results-output .results-articles').hide();

		} else {

			$('.search-results-output .results-articles').css('display', 'flex');
			$('.search-results-output .results-products').hide();

		}

	});

	// Product page image carousel

	$('.j-product-image-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: true,
		variableWidth: true,
		swipeToSlide: true,
		centerMode: true,
		mobileFirst: true,
		asNavFor: '.j-product-thumb-carousel',
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		      	variableWidth: false,
		      	centerMode: false,
		      	autoplay: false
		      }
		    }
		]
	});

	// Product page thumbs

	$('.j-product-thumb-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: false,
		variableWidth: true,
		swipeToSlide: true,
		centerMode: true,
		mobileFirst: true,
		asNavFor: '.j-product-image-carousel',
		focusOnSelect: true,
		responsive: [
		    {
		      breakpoint: 1024,
		      settings: {

		      }
		    }
		]
	});


	// Quantity selector interactions

	$(document).on('click', '.product-template .qty-selection span', function(){

        if( $(this).hasClass('minus') ){

        	$('.product-controls').removeClass('max-reached');

            if( $('.j-quantity-update').val() < 2 ){
                console.log('smaller than 0');
                $(this).addClass('disabled');
            } else {

                var counter = parseInt($('.j-quantity-update').val());
                counter--;
                $('.j-quantity-update').val(counter);
                $('.qty-selection span.minus').removeClass('disabled');

            }

        }

        if( $(this).hasClass('plus') ){

        	console.log('plus clicked');

        	if( $('.j-quantity-update').val() <= 4 ){

	            var counter = parseInt($('.j-quantity-update').val());
	            counter++;
	            $('.product-controls').removeClass('max-reached');
	            $('.j-quantity-update').val(counter);
	            $('.qty-selection span.minus').removeClass('disabled');
	            window.navigator.vibrate(100);

	        } else {

	        	$('.product-controls').addClass('max-reached');

	        }

        }

    });

    // Toggle tabs on product page

    $(document).on('click', '.j-product-tab', function(e){

    	e.preventDefault();
    	$(this).addClass('active').siblings().removeClass('active');
    	var tab = $(this).data('tab');
    	// $('.j-tab-' + tab + '').slideDown().siblings().slideUp();
    	$('.j-tab-' + tab + '').show().siblings().hide();

    });

    // Product template - show sticky add to cart button on scroll

    $(window).scroll(function() {
    	if ($(window).width() < 1024) {

	        if ($(document).scrollTop() > 200) {
	            $('.product-template .sticky-atc-btn').addClass('active');
	        }
	        else {
	            $('.product-template .sticky-atc-btn').removeClass('active');
	        }

	    }
    });



    // Blog search functionality

    // Search on team listing page

	$(document).on('submit', '.j-blog-search', function(e){

		e.preventDefault();

		$('.blog-articles').addClass('search-performed');
		$('.j-blog-article').removeClass('returned');

		var value = $('.j-blog-search-value').val().toLowerCase();
		console.log(value);

		$('.j-blog-article').each(function(){

			var text = $(this).data('name');

			if ( text.indexOf(value) != -1 ) {

				$(this).addClass('returned');

			}

		});

		var results = $('.j-blog-article.returned').length;

		if ( results == 0 ){

			console.log('no results');
			$('.j-blog-search').addClass('error');

			setTimeout(function(){

				$('.j-blog-search').removeClass('error');
				$('.blog-articles').removeClass('search-performed');

			}, 3000);

		} else {

			console.log('results');
			$(this).find('.j-clear-search').fadeIn();
			$('.j-blog-search').removeClass('error');

		}

	});

	// Remove inactive class if click outside

	$(document).mouseup(function(e) {

		var blog_ouput = $('.blog-articles');
	    if (!blog_ouput.is(e.target) && blog_ouput.has(e.target).length === 0) {
			$('.blog-articles').removeClass('search-performed');
	    }

	});

	$(document).on('click', '.j-clear-search', function(e) {

		e.preventDefault();
		var blog_ouput = $('.blog-articles');
	    if (!blog_ouput.is(e.target) && blog_ouput.has(e.target).length === 0) {
			$('.blog-articles').removeClass('search-performed');
	    }
	    $(this).fadeOut();
	    $('.j-blog-search-value').val('');

	});

	// Style images on article page

	$('.j-wsiwig-imgs img').each(function(){

		if ( $(this).attr('alt') == 'half' ){

			$(this).addClass('img-half');
			$(this).parent().addClass('image-wrapper');

		}

		if ( $(this).attr('alt') == 'full' ){

			$(this).addClass('img-full');
			$(this).parent().addClass('image-wrapper');

		}

	});

	// ecommerce functionality

	$(document).on('click', '.j-add-product', function(e){

		e.preventDefault();
		var button = $(this);
		var id = $(this).data('id');
		var qty = $(this).data('qty');
		var tags = $(this).data('tags');

		if ( $(this).hasClass('p-template') ){

			var qty = $('.product-controls .j-quantity-update').val();

		}

		var properties  = { _tags: tags };

		console.log(id, qty, properties);

		CartJS.addItem(id, qty, properties, {
		    "success": function(data, textStatus, jqXHR) {
		    	button.addClass('added');
		    	console.log('Added product');
		    },
		    "error": function(jqXHR, textStatus, errorThrown) {
		        console.log('Error: ' + errorThrown + '!');
		        $('.product-controls').addClass('error');
		        button.addClass('error');
		        button.text('Cannot add to bag');

		        setTimeout(function(){

		        	button.removeClass('error');
		        	button.text('Add to bag');

		        }, 3000);
		    }
		});

	});

	$(document).on('cart.requestComplete', function(event,cart) {

        $('.cart-counter').text(cart.item_count);

        setTimeout(function(){
        	$('.j-add-product').removeClass('added');
        }, 3000);

    });

    // Cart toggle

    $(document).on('click', '.j-toggle-cart', function(e){

    	e.preventDefault();
    	$('.cart-sidebar').toggleClass('active');
    	$('.cart_bg').fadeToggle();

    });


    // Faq toggle

	$(document).on('click', '.j-acc-title-toggle', function(e){

		$(this).parent().find('article').slideUp();
		$(this).parent().toggleClass('active').find('.q').removeClass('active').slideToggle();

	});

	$(document).on('click', '.j-acc-q-toggle', function(e){

		$(this).toggleClass('active').next('article').slideToggle();

	});

	// FAQ form submit

	$.expr[":"].contains = $.expr.createPseudo(function(arg) {
	    return function( elem ) {
	        return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
	    };
	});

	function close_all_faqs(){

		$('.faq-blocks .item').removeClass('active');
		$('.j-acc-q-toggle, .faq-blocks .item article').slideUp();

	};

	$(document).on('submit', '.j-faq-search', function(e){

		e.preventDefault();
		console.log('fired');
		var search = $('.j-faq-search-value').val();
		var container = $( '.faq-blocks .item article p:contains("'+search+'")');
		var content = $( '.faq-blocks .item article p span' );

		content.removeClass('highlight'); // remove highlighted state on submit

		if ( search.length >= 1 ){

			if ( container.length >= 1 ){
				container.wrapInner('<span class="highlight"></span>');
				$( '.highlight' ).parent().parent().prev().prev().trigger('click').next().trigger('click'); // open highlighted
				$('.j-faq-search').removeClass('error');
			} else {
				content.removeClass('highlight');
				$('.j-faq-search').addClass('error');
				close_all_faqs();
			}

		} else {
			content.removeClass('highlight');
			$('.j-faq-search').addClass('error');
			close_all_faqs();
		}
	});

	// Account login toggle

	var password_reset_block 	= $('.account-form-template .password-reset-block');
	var login_block 			= $('.account-form-template .login-block');

	$(document).on('click', '.j-forgotten-password', function(e){

		e.preventDefault();
		login_block.slideUp();
		password_reset_block.slideDown();


	});

	$(document).on('click', '.j-show-login', function(e){

		e.preventDefault();
		password_reset_block.slideUp();
		login_block.slideDown();


	});

	// Account address form toggle

	$(document).on('click', '.j-show-address-form', function(e){

		e.preventDefault();

		var formID = $(this).data('form-id');
		var allEditForms = $('.edit_address_forms .form');
		var selectedForm = $('#EditAddress_' + formID + '');

		allEditForms.slideUp();
		selectedForm.slideDown();

		setTimeout(function(){

			$('html,body').animate({
			   scrollTop: selectedForm.offset().top - 150
			});

		}, 500);

	});

	$(document).on('click', '.j-cancel-address-form', function(e){

		e.preventDefault();
		$('.edit_address_forms .form').slideUp();

	});

	// Toggle customer accounts

	$(document).on('click', '.j-account-tab', function(e){

		e.preventDefault();
		var tab = $(this).data('tab');
		$('.customer-section').hide();
		$('.customer-' + tab + '').show();
		$('.account-nav li a').removeClass('active');
		$(this).addClass('active');
		$('.j-line-item-product').matchHeight({ property: 'min-height' });

	});

	// Reordering logic

	$(document).on('click', '.j-repurchase-order', function(e){

		e.preventDefault();

		var this_item = $(this);

		var text = $(this).find('.rp-link').text();
		this_item.addClass('adding').find('.rp-link').text('Adding products to cart...');

		$(this).parent().siblings().each(function(){

			var reorder_variant_id = $(this).data('reorder_variant_id');
			var reorder_quantity = $(this).data('reorder_quantity');
			var reorder_availability = $(this).data('reorder_availability');

			if ( reorder_availability == true ){ // Check if produt is available before trying to add

				var properties  = {};

				CartJS.addItem(reorder_variant_id, reorder_quantity, properties, {
				    "success": function(data, textStatus, jqXHR) {
				    	console.log('Added product');
				    },
				    "error": function(jqXHR, textStatus, errorThrown) {
				        console.log('Error: ' + errorThrown + '!');
				    }
				});

			}

		});

		setTimeout(function(){

			this_item.removeClass('adding').addClass('added').find('.rp-link').text('Items are in your bag');

		},3000);

		setTimeout(function(){

			this_item.removeClass('added').find('.rp-link').text(text);

		},6000);



	});

	// Reorder logic for single order

	$(document).on('click', '.j-repurchase-single-order', function(e){

		e.preventDefault();

		var this_item = $(this);

		var text = $(this).text();
		this_item.addClass('adding').text('Adding products to cart...');

		$('.single-order-products .item').each(function(){

			var reorder_variant_id = $(this).data('reorder_variant_id');
			var reorder_quantity = $(this).data('reorder_quantity');
			var reorder_availability = $(this).data('reorder_availability');

			if ( reorder_availability == true ){ // Check if produt is available before trying to add

				var properties  = {};

				CartJS.addItem(reorder_variant_id, reorder_quantity, properties, {
				    "success": function(data, textStatus, jqXHR) {
				    	console.log('Added product');
				    },
				    "error": function(jqXHR, textStatus, errorThrown) {
				        console.log('Error: ' + errorThrown + '!');
				    }
				});

			}

		});

		setTimeout(function(){

			this_item.removeClass('adding').addClass('added').text('🎉 Items are in your bag');

		},3000);

		setTimeout(function(){

			this_item.removeClass('added').text(text);

		},6000);

	});

	// Open cart if URL contains cart=true

	if ( document.location.href.indexOf('?cart=true') > -1 ) {
        $('.cart-sidebar').addClass('active'); // open cart
        $('.cart_bg').fadeIn();
    }

    function cart_item_quantity_check(){

	    $('.cart-contents .cart-item').each(function(){

	    	var product_handle = $(this).find('.cart-item-footer').data('product-handle');
	    	var item_quantity = $(this).find('.j-quantity-update').val();

	    	if ( item_quantity >= 10 ){

	    		$('.j-p-template-' + product_handle + '').addClass('max-reached');
	    		//$('.j-p-template-' + product_handle + '').find('.j-quantity-update').val(item_quantity);

	    	}

	    	console.log('reached');


	    });

	};

	$(document).on('click', '.qty-selection span', function(){

		console.log('qty reacjed');
		cart_item_quantity_check();

	});

	// Run match height on j-collection-carousel blocks

	$('.j-collection-carousel .slick-slide').matchHeight({ property: 'min-height' });

	// Giftcard price change

	$(document).on('change', '.j-product-variants', function(){

		var selectedPrice = $(this).find("option:selected").data('vprice');
		var selectedID = $(this).find("option:selected").val();
		var button = $('.j-gc-btn');

		console.log(selectedPrice);
		button.text('Add to bag - ' + selectedPrice);
		button.data('id', selectedID);

	});

	// Show quiz

	$(document).on('click', '.j-show-quiz', function(e){

		e.preventDefault();
		$('.j-quiz-starting-div').hide();
		$('.regime-questions-wrapper').show();

	});

	// Bronto form ajax

	$("#bronto-form").submit(function(event) {

		event.preventDefault();

		/* get the action attribute from the <form action=""> element */
		var $form = $(this),
		url = $form.attr('action');

		/* Send the data using post with element id name and name2*/
		var posting = $.post(url, {
			email: $('#email').val()
		});

		/* Alerts the results */
		posting.done(function(data) {
			console.log('success');
			$('#result').text('success');
		});
		posting.fail(function() {
			console.log('failed');
			$('#result').text('failed');
		});

	});

	// Show search modal - header

	$(document).on('click', '.j-show-search-modal', function(e){

		e.preventDefault();
		$(this).toggleClass('triggered');
		$('.header-search-modal').slideToggle();

	});

	// Show product tips - quiz

	$(document).on('click', '.j-show-tips', function(e){

		e.preventDefault();
		$(this).parent().toggleClass('expanded');

		if ( $(this).parent().hasClass('expanded') ){

			$(this).text('Collapse');

		} else {

			$(this).text('Read more');

		}

	});

	// Set nav height on mobile when menu triggered

	function set_menu_height() {

		var innerHeight = window.innerHeight;
		var windowHeight = innerHeight - 72;
		$('.site-header .header .menu-wrapper').height(windowHeight);

	}

	if ($(window).width() < 1024) {

		set_menu_height();

		$(document).on('scroll', function(){

			set_menu_height();

		});

	}

	// Bronto signup checks

	if (window.location.href.indexOf("fs-true") > -1) {
    	alert("Footer signup has been completed");
    }

    if (window.location.href.indexOf("ls-true") > -1) {
    	alert("FLightbox signup has been completed");
    }

    $('.slick-slider').show().css('visibility', 'visible'); // Show all carousels once page loaded - must be after all slick calls


	// IE11 detection

	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	var IE11Warning = '<div class="browser-warning"><p>We only offer partial support for this browser. To get the best experience we recommend downloading <a href="https://www.google.com/intl/en/chrome/" target="_blank"><u>Google Chrome</u></a>.</p><span class="close-icon j-close-browser-warning"></span></div>';

	if ( isIE11 == true ){

		body.append(IE11Warning);

		$(document).on('click', '.j-close-browser-warning', function(e){

			$('.browser-warning').fadeOut();

		});

	}

});